import { render, staticRenderFns } from "./MarketAnalysis.vue?vue&type=template&id=2639f84f"
import script from "./MarketAnalysis.vue?vue&type=script&lang=js"
export * from "./MarketAnalysis.vue?vue&type=script&lang=js"
import style0 from "./MarketAnalysis.vue?vue&type=style&index=0&id=2639f84f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports